/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';

const defaultNavItems: FuseNavigationItem[] = [
    {
      id: 'my-dashboard',
      title: 'My dashboard',
      type: 'basic',
      icon: 'heroicons_outline:home',
      link: '/my-dashboard',
    },
    {
      id: 'dashboard',
      title: 'Team dashboard',
      type: 'basic',
      icon: 'heroicons_outline:chart-bar',
      link: '/dashboard',
    },
    {
      id: 'users_and_accounts',
      title: 'Users & Accounts',
      type: 'aside',
      icon: 'heroicons_outline:user-group',
      children: [
        {
          type: 'group',
          title: 'User Management'
        },
        {
          id: 'users',
          title: 'Users',
          type: 'basic',
          icon: 'heroicons_outline:user-circle',
          link: '/users',
        },
        {
          id: 'vendors',
          title: 'Vendors',
          type: 'basic',
          icon: 'heroicons_outline:currency-dollar',
          link: '/vendors',
        },
        {
          id: 'user-completion',
          title: 'Profile Completion',
          type: 'collapsable',
          icon: 'heroicons_outline:check-circle',
          children: [
            {
              id: 'user-completion-dashboard',
              title: 'Dashboard',
              type: 'basic',
              link: '/user-completion/dashboard'
            },
            {
              id: 'user-completion-list',
              title: 'User List',
              type: 'basic',
              link: '/user-completion',
            },
            {
              id: 'completion-requirements',
              title: 'Requirements',
              type: 'basic',
              link: '/completion-requirements/list',
            }
          ]
        },
        {
          type: 'divider'
        },
        {
          type: 'group',
          title: 'Verification & Credentials'
        },
        {
          id: 'insurance',
          title: 'Insurance',
          type: 'basic',
          icon: 'heroicons_outline:document-text',
          link: '/user-insurance'
        },
        {
          id: 'food_safety',
          title: 'Food Safety',
          type: 'basic',
          icon: 'heroicons_outline:shield-check',
          link: '/user-food-safety'
        },
        {
          id: 'fuse',
          title: 'Fuse Applications',
          type: 'basic',
          icon: 'heroicons_outline:document-text',
          link: '/fuse'
        },
        {
          type: 'divider'
        },
        {
          type: 'group',
          title: 'Payments & Billing'
        },
        {
          id: 'stripe_accounts',
          title: 'Stripe Accounts',
          type: 'basic',
          icon: 'heroicons_outline:credit-card',
          link: '/admin/stripe-accounts'
        },
        {
          id: 'stripe_customers',
          title: 'Stripe Customers',
          type: 'basic',
          icon: 'heroicons_outline:user-group',
          link: '/admin/stripe-customers'
        }
      ]
    },
    {
      id: 'communication_and_engagement',
      title: 'Communication',
      type: 'aside',
      icon: 'heroicons_outline:chat-bubble-left-right',
      children: [
        {
          type: 'group',
          title: 'User Interactions'
        },
        {
          id: 'conversations',
          title: 'Conversations',
          type: 'basic',
          icon: 'heroicons_outline:chat-bubble-left-right',
          link: '/conversations',
        },
        {
          id: 'calls',
          title: 'Calls',
          type: 'basic',
          icon: 'heroicons_outline:phone',
          link: '/calls',
        },
        {
          id: 'leads',
          title: 'Leads',
          type: 'basic',
          icon: 'heroicons_outline:user-plus',
          link: '/leads',
        },
        {
          id: 'lifecycle',
          title: 'Lifecycle',
          type: 'basic',
          icon: 'heroicons_outline:arrow-path',
          link: '/lifecycle',
        },
        {
          id: 'onboarding',
          title: 'Onboarding',
          type: 'basic',
          icon: 'heroicons_outline:rocket-launch',
          link: '/onboarding',
        },
        {
          id: 'flagged',
          title: 'Flagged',
          type: 'basic',
          icon: 'heroicons_outline:flag',
          link: '/flagged'
        },
        {
          id: 'tickets',
          title: 'Tickets',
          type: 'basic',
          icon: 'heroicons_outline:ticket',
          link: '/tickets',
        },
        {
          id: 'reviews',
          title: 'Reviews',
          type: 'basic',
          icon: 'heroicons_outline:star',
          link: '/reviews',
        },
        {
          type: 'divider'
        },
        {
          type: 'group',
          title: 'Notifications'
        },
        {
          id: 'notifications',
          title: 'Notifications',
          type: 'basic',
          icon: 'heroicons_outline:bell',
          link: '/notifications',
        },
        {
          id: 'notification-templates',
          title: 'Notification Templates',
          type: 'basic',
          icon: 'heroicons_outline:bell',
          link: '/notification-templates',
        },
        {
          id: 'emails',
          title: 'Emails',
          type: 'basic',
          icon: 'heroicons_outline:at-symbol',
          link: '/email'
        },
        {
          id: 'email-keys',
          title: 'Email Keys',
          type: 'basic',
          icon: 'heroicons_outline:key',
          link: '/email-key'
        },
        {
          id: 'email-templates',
          title: 'Email Templates',
          type: 'basic',
          icon: 'heroicons_outline:envelope',
          link: '/email-templates'
        },
        {
          id: 'email-analytics',
          title: 'Email Analytics',
          type: 'basic',
          icon: 'heroicons_outline:chart-bar',
          link: '/email-analytics'
        },
        {
          id: 'twilio_numbers',
          title: 'Twilio Numbers',
          type: 'basic',
          icon: 'heroicons_outline:phone',
          link: '/twilio-numbers'
        },
        {
          id: 'aircall_lines',
          title: 'Aircall Lines',
          type: 'basic',
          icon: 'heroicons_outline:phone',
          link: '/aircall-lines'
        }
      ]
    },
    {
      id: 'listings',
      title: 'Listings',
      type: 'aside',
      icon: 'heroicons_outline:map',
      children: [
        {
          type: 'group',
          title: 'Places & Facilities'
        },
        {
          id: 'section',
          title: 'Sections',
          type: 'basic',
          icon: 'heroicons_outline:map',
          link: '/places',
        },
        {
          id: 'kitchen',
          title: 'Kitchens',
          type: 'basic',
          icon: 'heroicons_outline:building-storefront',
          link: '/facilities',
        },
        {
          id: 'availability',
          title: 'Availability',
          type: 'collapsable',
          icon: 'heroicons_outline:map-pin',
          children: [
            {
              id: 'place_cities',
              title: 'City Availability',
              type: 'basic',
              link: '/place-city',
            },
            {
              id: 'request_city',
              title: 'City Requests',
              type: 'basic',
              link: '/request-city',
            },
          ]
        },
        {
          id: 'facility_document_types',
          title: 'Facility Doc Types',
          type: 'basic',
          icon: 'heroicons_outline:document-check',
          link: '/facility-document-types',
        },
        {
          type: 'divider'
        },
        {
          type: 'group',
          title: 'Listing Categories & Features'
        },
        {
          id: 'categories',
          title: 'Categories',
          type: 'basic',
          icon: 'heroicons_outline:tag',
          link: '/categories',
        },
        {
          id: 'equipment_categories',
          title: 'Equipment Categories',
          type: 'basic',
          icon: 'heroicons_outline:sparkles',
          link: '/equipment-categories',
        },
        {
          id: 'features',
          title: 'Features',
          type: 'basic',
          icon: 'heroicons_outline:truck',
          link: '/features',
        },
        {
          id: 'dietary_restrictions',
          title: 'Dietary Restrictions',
          type: 'basic',
          icon: 'heroicons_outline:beaker',
          link: '/dietary-restriction',
        },
        {
          type: 'divider'
        },
        {
          type: 'group',
          title: 'Add-ons & Extras'
        },
        {
          id: 'booking_add_ons',
          title: 'Booking add-ons',
          type: 'basic',
          icon: 'heroicons_outline:plus-circle',
          link: '/booking-add-ons'
        },
        {
          id: 'booking_add_on_categories',
          title: 'Booking add-on categories',
          type: 'basic',
          icon: 'heroicons_outline:presentation-chart-line',
          link: '/booking-add-on-categories'
        },
        {
          id: 'booking_add_on_templates',
          title: 'Booking add-on templates',
          type: 'basic',
          icon: 'heroicons_outline:document-duplicate',
          link: '/booking-add-on-templates'
        }
      ]
    },
    {
      id: 'sales_and_bookings',
      title: 'Sales & Bookings',
      type: 'aside',
      icon: 'heroicons_outline:currency-dollar',
      children: [
        {
          type: 'group',
          title: 'Bookings & Subscriptions'
        },
        {
          id: 'bookings',
          title: 'Bookings',
          type: 'basic',
          icon: 'heroicons_outline:book-open',
          link: '/bookings',
        },
        {
          id: 'syzl_subscriptions',
          title: 'Syzl Subscriptions',
          type: 'basic',
          icon: 'heroicons_outline:document-text',
          link: '/syzl-subscriptions'
        },
        {
          id: 'smarter_u_account',
          title: 'SmarterU Accounts',
          type: 'basic',
          icon: 'heroicons_outline:academic-cap',
          link: '/smarter-u-account'
        },
        {
          id: 'user_packages',
          title: 'Host Packages (WIP)',
          type: 'basic',
          icon: 'heroicons_outline:megaphone',
          link: '/user-packages',
        },
        {
          id: 'booking_rules',
          title: 'Booking Rules',
          type: 'basic',
          icon: 'heroicons_outline:check-circle',
          link: '/booking-rules'
        },
        {
          type: 'divider'
        },
        {
          type: 'group',
          title: 'Payments & Revenue'
        },
        {
          id: 'booking_failed_payments',
          title: 'Booking Failed Payments',
          type: 'basic',
          icon: 'heroicons_outline:exclamation-triangle',
          link: '/booking-failed-payments'
        },
        {
          id: 'booking_failed_transfers',
          title: 'Booking Failed Transfers',
          type: 'basic',
          icon: 'heroicons_outline:banknotes',
          link: '/booking-failed-transfers'
        },
        {
          type: 'divider'
        },
        {
          type: 'group',
          title: 'Promotions & Discounts'
        },
        {
          id: 'booking_fees',
          title: 'Booking Fee Promos',
          type: 'basic',
          icon: 'heroicons_outline:receipt-percent',
          link: '/booking-fees',
        },
        {
          id: 'customer_credits',
          title: 'Customer Credits',
          type: 'basic',
          icon: 'heroicons_outline:receipt-refund',
          link: '/customer-credits',
        },
        {
          id: 'promo_codes',
          title: 'Promo Codes',
          type: 'basic',
          icon: 'heroicons_outline:percent-badge',
          link: '/promo-codes',
        },
        {
          type: 'divider'
        },
        {
          type: 'group',
          title: 'Bulk Operations'
        },
        {
          id: 'bulk_companies',
          title: 'Bulk Companies',
          type: 'basic',
          icon: 'heroicons_outline:briefcase',
          link: '/bulk-companies',
        },
        {
          id: 'bulk_deals',
          title: 'Bulk Deals',
          type: 'basic',
          icon: 'heroicons_outline:briefcase',
          link: '/bulk-deals',
        },
        {
          id: 'bulk_bookings',
          title: 'Bulk Bookings',
          type: 'basic',
          icon: 'heroicons_outline:briefcase',
          link: '/bulk-bookings',
        }
      ]
    },
    {
      id: 'marketing',
      title: 'Marketing',
      type: 'aside',
      icon: 'heroicons_outline:presentation-chart-line',
      children: [
        {
          type: 'group',
          title: 'Customer Targeting'
        },
        {
          id: 'icp',
          title: 'Ideal Customer Profiles',
          type: 'basic',
          icon: 'heroicons_outline:presentation-chart-line',
          link: '/icp'
        },
        {
          id: 'icp-landing-page',
          title: 'Landing Pages',
          type: 'basic',
          icon: 'heroicons_outline:presentation-chart-line',
          link: '/icp-landing-page'
        },
        {
          type: 'divider'
        },
        {
          type: 'group',
          title: 'Content'
        },
        {
          id: 'pages',
          title: 'Pages',
          type: 'basic',
          icon: 'heroicons_outline:document-text',
          link: '/pages',
        },
        {
          id: 'posts',
          title: 'Posts',
          type: 'basic',
          icon: 'heroicons_outline:rss',
          link: '/posts',
        },
        {
          id: 'help-center',
          title: 'Help Center',
          type: 'basic',
          icon: 'heroicons_outline:question-mark-circle',
          link: '/help-center',
        },
        {
          id: 'slide_images',
          title: 'Slider Images',
          type: 'basic',
          icon: 'heroicons_outline:photo',
          link: '/slider-images',
        },
        {
          id: 'slides',
          title: 'Slides Intro',
          type: 'basic',
          icon: 'heroicons_outline:photo',
          link: '/slides-intro',
        },
        {
          type: 'divider'
        },
        {
          type: 'group',
          title: 'Products'
        },
        {
          id: 'packages',
          title: 'Packages (WIP)',
          type: 'basic',
          icon: 'heroicons_outline:megaphone',
          link: '/packages',
        },
        {
          id: 'smarter_u_dummy',
          title: 'SmarterU Dummies',
          type: 'basic',
          icon: 'heroicons_outline:puzzle-piece',
          link: '/smarter-u-dummy'
        },
      ]
    },
    {
      id: 'analytics',
      title: 'Analytics',
      type: 'aside',
      icon: 'heroicons_outline:chart-bar',
      children: [
        {
          type: 'group',
          title: 'Data Visualization'
        },
        {
          id: 'mongo_charts',
          title: 'MongoDB Charts',
          type: 'basic',
          icon: 'heroicons_outline:chart-bar',
          link: '/mongo-charts',
        },
        {
          id: 'analytics_bookings',
          title: 'Bookings',
          type: 'basic',
          icon: 'heroicons_outline:calendar-days',
          link: '/analytics/bookings',
        },
        {
          id: 'kitchens',
          title: 'Kitchens',
          type: 'basic',
          icon: 'heroicons_outline:home',
          link: '/analytics/kitchens',
        }
      ]
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'basic',
      icon: 'heroicons_outline:cog',
      link: '/settings',
    }
  ];

export const navigationData: Navigation = {
    compact: defaultNavItems,
    default: defaultNavItems,
    futuristic: defaultNavItems,
    horizontal: defaultNavItems
};